import React, { useEffect } from 'react'
import { Card, Descriptions, Spin, Table, Tag } from 'antd'
import moment from 'moment'

const SECTION_TITLE_COLOR = 'rgba(0, 0, 0, 0.85)'

// Sectioned container with a transparent header bar and a visible title,
// matching the create/edit page layout.
function Section ({ title, children, style }) {
  return (
    <Card
      type='inner'
      title={<span style={{ color: SECTION_TITLE_COLOR, fontWeight: 600, letterSpacing: 0.5 }}>{title}</span>}
      headStyle={{ background: 'transparent', minHeight: 40 }}
      bodyStyle={{ padding: 16 }}
      style={{ marginBottom: 16, ...(style || {}) }}
    >
      {children}
    </Card>
  )
}

const fmtDate = (d) => d ? moment(d).format('DD/MM/YYYY HH:mm') : '-'
const fmtGeo = (g) => {
  if (!g) return '-'
  const parts = []
  if (g.latitude != null || g.longitude != null) parts.push(`${g.latitude != null ? g.latitude : '-'}, ${g.longitude != null ? g.longitude : '-'}`)
  if (g.address) parts.push(g.address)
  return parts.length ? parts.join(' | ') : '-'
}
const prettify = (v) => (v ? v.charAt(0) + v.slice(1).toLowerCase() : '-')

const STATUS_COLORS = {
  DRAFT: 'default', PLANNED: 'blue', ASSIGNED: 'cyan', STARTED: 'green',
  PAUSED: 'orange', COMPLETED: 'geekblue', CANCELLED: 'red'
}

function View (props) {
  const { match, fetch, data, loading } = props

  useEffect(() => {
    if (match && match.params && match.params.id) {
      fetch(match.params.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match && match.params && match.params.id])

  const record = data || {}
  const asset = record.asset || {}
  const manpower = record.manpower || {}
  const statusHistory = record.statusHistory || []
  const documents = record.documents || []

  const statusColumns = [
    {
      title: 'Stage',
      dataIndex: 'status',
      render: (s) => <Tag color={STATUS_COLORS[s] || 'default'}>{prettify(s)}</Tag>
    },
    { title: 'Date & Time', dataIndex: 'dateTime', render: (d) => fmtDate(d) },
    { title: 'Remark', dataIndex: 'remark', render: (r) => r || '-' },
    { title: 'By', dataIndex: 'createdBy', render: (u) => (u && u.name) || '-' }
  ]

  return (
    <Spin spinning={loading}>
      <Card className='gx-card-metrics' title={`Fleet Trip ${record.tripNo ? `- ${record.tripNo}` : ''}`}>

        <Section title='TRIP INFORMATION'>
          <Descriptions bordered column={{ xs: 1, sm: 1, md: 2 }} size='small'>
            <Descriptions.Item label='Trip No'>{record.tripNo || '-'}</Descriptions.Item>
            <Descriptions.Item label='Trip Name'>{record.tripName || '-'}</Descriptions.Item>
            <Descriptions.Item label='Status'>
              <Tag color={STATUS_COLORS[record.tripStatus] || 'default'}>{prettify(record.tripStatus)}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label='Trip Type'>{prettify(record.tripType)}</Descriptions.Item>
            <Descriptions.Item label='Asset'>
              {asset.assetCode ? `${asset.assetCode}${asset.altName ? ` (${asset.altName})` : ''}` : '-'}
            </Descriptions.Item>
            <Descriptions.Item label='Operator'>{manpower.name || '-'}</Descriptions.Item>
            <Descriptions.Item label='Description' span={2}>{record.description || '-'}</Descriptions.Item>
          </Descriptions>
        </Section>

        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-start' }}>
          <div style={{ flex: '1 1 320px', minWidth: 0 }}>
            <Section title='PROPOSED START'>
              <Descriptions bordered column={1} size='small'>
                <Descriptions.Item label='Proposed Start'>{fmtDate(record.proposedStartDateTime)}</Descriptions.Item>
                <Descriptions.Item label='Proposed Start Location'>{fmtGeo(record.proposedStartLocation)}</Descriptions.Item>
                <Descriptions.Item label='Actual Start'>{fmtDate(record.actualStartDateTime)}</Descriptions.Item>
                <Descriptions.Item label='Actual Start Location'>{fmtGeo(record.actualStartLocation)}</Descriptions.Item>
              </Descriptions>
            </Section>
          </div>
          <div style={{ flex: '1 1 320px', minWidth: 0 }}>
            <Section title='PROPOSED END'>
              <Descriptions bordered column={1} size='small'>
                <Descriptions.Item label='Proposed End'>{fmtDate(record.proposedEndDateTime)}</Descriptions.Item>
                <Descriptions.Item label='Proposed End Location'>{fmtGeo(record.proposedEndLocation)}</Descriptions.Item>
                <Descriptions.Item label='Actual End'>{fmtDate(record.actualEndDateTime)}</Descriptions.Item>
                <Descriptions.Item label='Actual End Location'>{fmtGeo(record.actualEndLocation)}</Descriptions.Item>
              </Descriptions>
            </Section>
          </div>
        </div>

        <Section title='ADDITIONAL DETAILS'>
          <Descriptions bordered column={1} size='small' style={{ marginBottom: documents.length > 0 ? 16 : 0 }}>
            <Descriptions.Item label='Remarks'>{record.remarks || '-'}</Descriptions.Item>
          </Descriptions>
          {documents.length > 0 && (
            <div>
              <div style={{ marginBottom: 6, fontWeight: 600 }}>Documents</div>
              {documents.map((doc, idx) => (
                <div key={idx} style={{ marginBottom: 6 }}>
                  <a href={doc.url} target='_blank' rel='noopener noreferrer'>{doc.name || doc.url}</a>
                </div>
              ))}
            </div>
          )}
        </Section>

        <Section title='STATUS TIMELINE' style={{ marginBottom: 0 }}>
          <Table
            rowKey={(r, i) => (r._id || i)}
            columns={statusColumns}
            dataSource={statusHistory}
            size='small'
            pagination={false}
          />
        </Section>
      </Card>
    </Spin>
  )
}

export default View
